import React from 'react';
import {Card, CardBody} from 'reactstrap';

import type {ComponentType, FC} from 'react';
import type {PlaceholderValues} from '@touchnet/user-management';
import {RoleScopesDisplay} from "@touchnet/user-management/build/urps/role-manager/_story-components/interfaces";



interface ComponentProps {
    DetailsComponent: ComponentType;
    roleCode: string;
    scopes: PlaceholderValues[];
}

export const RoleDetailsWithScopes: FC<ComponentProps> = (props: ComponentProps) => {
    const {DetailsComponent, roleCode, scopes} = props;


    let ScopesDisplay: ComponentType<RoleScopesDisplay>;

    switch (roleCode) {
        default:
            ScopesDisplay = React.Fragment;
            break;
    }

    return (
        <React.Fragment>
            <dl className="row">
                <dt className="col-12 col-sm-3">Role</dt>
                <dd className="col-12 col-sm-9">ERP Admin</dd>
                <ScopesDisplay roleCode={roleCode} scopes={scopes} />
            </dl>
            <Card className="bg-light">
                <CardBody>
                    <DetailsComponent />
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default RoleDetailsWithScopes;
